import {ConnectBasicEntityExt} from '../../framework/message/ConnectBasicEntityExt';

export class PredefinedStep extends ConnectBasicEntityExt {}

